<template>
    <div class="page-about-vacancies">
        <div class="col-container">
            <div class="col-left">
                <div class="vacancies-desc" v-html="aboutPage.work_desc"></div>
            </div>
            <div class="col-right">
                <formVacancy></formVacancy>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import formVacancy from '@/components/forms/form-vacancy.vue'

    export default {
        name: 'about-page-vacancies',
        components: {
            formVacancy,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Работа в компании',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        beforeCreate() {
            document.body.dataset.page = 'about-vacancies';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/vacancies-section.scss';
    @import '@/styles/components/about-page/respond/vacancies-section-respond.scss';
</style>